///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { currencies, division } from "./types";

export const getCurrency = userOrBidDivision => {
  return userOrBidDivision === division.coy
    ? currencies.dollar
    : currencies.euro;
};

export default getCurrency;
